import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

// Интерфейс пропсов для мобильных элементов управления
interface MobileControlsProps {
  onMove: (direction: 'up' | 'down' | 'left' | 'right') => void;  // Функция обработки движения
  isMobile: boolean;                                              // Флаг мобильного устройства
}

// Компонент мобильных элементов управления
export const MobileControls = ({ onMove, isMobile }: MobileControlsProps) => {
  // Не отображаем элементы управления на десктопе
  if (!isMobile) return null;

  return (
    <div className="fixed bottom-4 right-4 z-20">
      {/* Сетка 3x3 для расположения кнопок в виде крестовины */}
      <div className="grid grid-cols-3 gap-2 w-32">
        <div></div>
        {/* Кнопка движения вверх */}
        <Button
          variant="secondary"
          size="sm"
          className="h-12 w-12 p-0"
          onTouchStart={() => onMove('up')}
        >
          <ArrowUp className="h-6 w-6" />
        </Button>
        <div></div>
        
        {/* Кнопка движения влево */}
        <Button
          variant="secondary"
          size="sm"
          className="h-12 w-12 p-0"
          onTouchStart={() => onMove('left')}
        >
          <ArrowLeft className="h-6 w-6" />
        </Button>
        {/* Кнопка движения вниз */}
        <Button
          variant="secondary"
          size="sm"
          className="h-12 w-12 p-0"
          onTouchStart={() => onMove('down')}
        >
          <ArrowDown className="h-6 w-6" />
        </Button>
        {/* Кнопка движения вправо */}
        <Button
          variant="secondary"
          size="sm"
          className="h-12 w-12 p-0"
          onTouchStart={() => onMove('right')}
        >
          <ArrowRight className="h-6 w-6" />
        </Button>
      </div>
    </div>
  );
};